import React, { useState, useEffect } from 'react';
import { FaSun, FaMoon, FaClipboard } from 'react-icons/fa';

function App() {
  // Set default darkMode true agar dark mode aktif saat pertama load
  const [phone, setPhone] = useState('');
  const [link, setLink] = useState('');
  const [darkMode, setDarkMode] = useState(() => {
    // Prioritaskan simpanan user, jika tidak ada set true (dark mode default)
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light') return false;
    return true;
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  const cleanPhoneNumber = (number) => {
    let cleaned = number.replace(/[^\d]/g, '');
    if (cleaned.startsWith('0')) cleaned = '62' + cleaned.slice(1);
    if (!cleaned.startsWith('62')) cleaned = '62' + cleaned;
    return cleaned;
  };

  const generateLink = () => {
    if (!phone.trim()) {
      alert('Masukkan nomor telepon terlebih dahulu!');
      return;
    }
    const cleaned = cleanPhoneNumber(phone.trim());
    setLink(`https://wa.me/${cleaned}`);
  };

  const pasteFromClipboard = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setPhone(text);
    } catch (error) {
      alert('Gagal mengakses clipboard: ' + error);
    }
  };

  return (
    <div className="min-h-screen transition-colors duration-500 bg-white dark:bg-gray-900 p-4 pt-8 flex justify-center">
      <div className="max-w-md w-full p-6 bg-gray-50 dark:bg-gray-800 rounded-lg shadow-lg text-gray-900 dark:text-gray-100 font-sans">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-green-700 dark:text-green-400">
            WhatsApp Link Generator
          </h2>

          <button
            onClick={() => setDarkMode(!darkMode)}
            className="p-2 rounded-full bg-green-600 text-white hover:bg-green-700 transition focus:outline-none"
            aria-label="Toggle Dark Mode"
            title="Toggle Dark Mode"
          >
            {darkMode ? <FaSun size={20} /> : <FaMoon size={20} />}
          </button>
        </div>

        {/* Input with animated paste button */}
        <div className="relative mb-4">
          <input
            type="text"
            placeholder="Masukkan nomor telepon"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="w-full p-3 pr-12 border border-green-400 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 dark:bg-gray-700 dark:border-green-500 text-gray-900 dark:text-gray-100 transition-colors duration-300"
          />
          <button
            onClick={pasteFromClipboard}
            className="absolute top-1/2 right-2 transform -translate-y-1/2 p-2 text-green-600 dark:text-green-400 transition transform hover:scale-110 hover:text-green-800 dark:hover:text-green-200 focus:outline-none"
            title="Paste dari Clipboard"
            aria-label="Paste dari Clipboard"
            type="button"
          >
            <FaClipboard size={18} />
          </button>
        </div>

        <button
          onClick={generateLink}
          className="w-full py-3 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
        >
          Generate Link WhatsApp
        </button>

        {link && (
          <div className="mt-6 p-4 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300 rounded-md break-words text-center transition-colors duration-500">
            <a href={link} target="_blank" rel="noopener noreferrer" className="underline">
              {link}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
